module.exports = __webpack_public_path__ + "static/inno2-9de707ee445e9aaa151a9ce510fe5b53.jpg";